<template>
<div>
    <div class="form-row">
        <div class="col-4">
            <form-input :model-value="settings.accrual_hours" @update:model-value="update('accrual_hours', $event)" :errors="errors.accrual_hours" type="decimal" label="Accrual Rate" :helper-text="rateHelperText" />
        </div>
        <div class="col-4" v-if="method == 'hours-worked'">
            <form-input :model-value="settings.per_hours_worked" @update:model-value="update('per_hours_worked', $event)" :errors="errors.per_hours_worked" type="decimal" label="Per Hours Worked" />
        </div>
    </div>

    <!-- Settings that exist on the base tier only. -->
    <slot></slot>

    <h5 class="text-uppercase mt-3 mb-1">Rollover Rules</h5>
    <div class="form-row mb-2">
        <div class="col">
            <form-input :model-value="settings.rollover_enabled" @update:model-value="update('rollover_enabled', $event)" :errors="errors.rollover_enabled" type="checkbox" label="Enable Rollover" />
        </div>
    </div>
    <div class="form-row" v-if="settings.rollover_enabled">
        <div class="col-6">
            <form-input :model-value="settings.max_rollover_hours" @update:model-value="update('max_rollover_hours', $event)" :errors="errors.max_rollover_hours" type="decimal" label="Max Hours to Rollover" helper-text="Blank for unlimited." />
        </div>
    </div>

    <h5 class="text-uppercase mt-3 mb-1">Balance and Usage Limits</h5>
    <div class="form-row">
        <div class="col-4">
            <form-input :model-value="settings.max_balance_hours" @update:model-value="update('max_balance_hours', $event)" :errors="errors.max_balance_hours" type="decimal" label="Annual Balance Limit" helper-text="Blank for unlimited." />
        </div>
        <div class="col-4">
            <form-input :model-value="settings.max_accrued_per_year" @update:model-value="update('max_accrued_per_year', $event)" :errors="errors.max_accrued_per_year" type="decimal" label="YTD Accrual Limit" helper-text="Blank for unlimited." />
        </div>
        <div class="col-4">
            <form-input :model-value="settings.max_taken_per_year" @update:model-value="update('max_taken_per_year', $event)" :errors="errors.max_taken_per_year" type="decimal" label="YTD Taken Limit" helper-text="Blank for unlimited." />
        </div>
    </div>
</div>
</template>

<script>
export default {
    props: {
        settings: {type: Object, required: true},
        errors: {type: Object, default: () => ({})},
        method: {type: String, required: true},
    },
    emits: ['update:settings'],
    computed: {
        rateHelperText() {
            return {
                'pay-period': 'Hours per pay cycle',
                'hours-worked': 'Hours accrued per the hours worked',
                'set-balance': 'Hours per accrual year',
            }[this.method]
        },
    },
    methods: {
        update(field, value) {
            this.$emit('update:settings', {...this.settings, [field]: value})
        },
    },
}
</script>
